import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { PilotEntity } from './pilot.model';

export enum PilotActionTypes {
  LoadPilots = '[Pilot] Load Pilots',
  AddPilot = '[Pilot] Add Pilot',
  UpsertPilot = '[Pilot] Upsert Pilot',
  AddPilots = '[Pilot] Add Pilots',
  UpsertPilots = '[Pilot] Upsert Pilots',
  UpdatePilot = '[Pilot] Update Pilot',
  UpdatePilots = '[Pilot] Update Pilots',
  DeletePilot = '[Pilot] Delete Pilot',
  DeletePilots = '[Pilot] Delete Pilots',
  ClearPilots = '[Pilot] Clear Pilots',
}

export class LoadPilots implements Action {
  public readonly type = PilotActionTypes.LoadPilots;

  constructor(public payload: { pilots: PilotEntity[] }) {}
}

export class AddPilot implements Action {
  public readonly type = PilotActionTypes.AddPilot;

  constructor(public payload: { pilot: PilotEntity }) {}
}

export class UpsertPilot implements Action {
  public readonly type = PilotActionTypes.UpsertPilot;

  constructor(public payload: { pilot: PilotEntity }) {}
}

export class AddPilots implements Action {
  public readonly type = PilotActionTypes.AddPilots;

  constructor(public payload: { pilots: PilotEntity[] }) {}
}

export class UpsertPilots implements Action {
  public readonly type = PilotActionTypes.UpsertPilots;

  constructor(public payload: { pilots: PilotEntity[] }) {}
}

export class UpdatePilot implements Action {
  public readonly type = PilotActionTypes.UpdatePilot;

  constructor(public payload: { pilot: Update<PilotEntity> }) {}
}

export class UpdatePilots implements Action {
  public readonly type = PilotActionTypes.UpdatePilots;

  constructor(public payload: { pilots: Update<PilotEntity>[] }) {}
}

export class DeletePilot implements Action {
  public readonly type = PilotActionTypes.DeletePilot;

  constructor(public payload: { id: string }) {}
}

export class DeletePilots implements Action {
  public readonly type = PilotActionTypes.DeletePilots;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPilots implements Action {
  public readonly type = PilotActionTypes.ClearPilots;
}

export type PilotActions =
  | LoadPilots
  | AddPilot
  | UpsertPilot
  | AddPilots
  | UpsertPilots
  | UpdatePilot
  | UpdatePilots
  | DeletePilot
  | DeletePilots
  | ClearPilots;
